import angular from 'angular';
import { EventsSchedulingTsuReportContainerComponent } from './event-scheduling-tsu-report/event-scheduling-tsu-report-container.component';
import { EventsSchedulingTsuSummaryReportComponent } from './event-scheduling-tsu-report/event-scheduling-tsu-summary-report.component';
import { EventsSchedulingEmployeeTsuReportComponent } from './event-scheduling-tsu-report/event-scheduling-employee-tsu-report.component';

export const EventsSchedulingReportModule = angular
    .module("apex.mainApp.eventsScheduling.reports", [])
    .component("apexEventsSchedulingTsuReportContainer", EventsSchedulingTsuReportContainerComponent)
    .component("apexEventsSchedulingTsuSummaryReport", EventsSchedulingTsuSummaryReportComponent)
    .component("apexEventsSchedulingEmployeeTsuReport", EventsSchedulingEmployeeTsuReportComponent)
    .name;
